import { Box, ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { Translate } from "src/assets/data/index";
import LinkIcon from "src/components/ui/svgIcon/LinkIcon";
import PrimaryHoverEffect from "src/components/ui/warehouse/primaryHoverEffect";
import ChainModalSection from "./ChainModalSection";
import { ChainMenuBox } from "../MenuStyle";

const ChainSection = (menu) => {
  const theme = useTheme();
  const [anchorChainMenuEl, setAnchorChainMenuEl] = useState(null);
  const openChainMenu = Boolean(anchorChainMenuEl);
  const handleChainMenuClick = (event) => {
    setAnchorChainMenuEl(event.currentTarget);
  };
  const handleChainMenuClose = () => setAnchorChainMenuEl(null);
  return (
    <Box>
      <Stack mt={1} sx={{ justifyContent: "space-around", height: 80 }}>
        <Stack flexDirection="row" justifyContent="center" alignItems="center" height={0.5}>
          <PrimaryHoverEffect heighteffect={65} className={openChainMenu ? "active" : ""}>
            <ButtonBase
              variant="text"
              onClick={handleChainMenuClick}
              sx={{
                transform: "rotate(90deg)",
                minWidth: "unset",
                color: "text.primary",
                p: 0.5,              
              }}
            >
              <Typography variant="body2" sx={{ marginInlineEnd: 1 }}>
                {Translate.translate.texts.chain}
              </Typography>
              <LinkIcon fontSize="small" color={theme.palette.text.primary} />
            </ButtonBase>
          </PrimaryHoverEffect>

          <ChainMenuBox anchorEl={anchorChainMenuEl} open={openChainMenu} onClose={handleChainMenuClose}>
            <ChainModalSection menu={menu} handleClose={handleChainMenuClose} />
          </ChainMenuBox>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ChainSection;
